import { useMemo } from 'react';

import { IQuestion } from '../models';

interface IProps {
  optionId?: number;
  question?: IQuestion;
  selectedOption?: number | null;
  isAnswered?: boolean;
}

export const useOptionStatus = ({ optionId, question, selectedOption, isAnswered }: IProps) =>
  useMemo(() => {
    if (!question) return { isSuccess: false, isWrong: false };

    const hasAnswered = Boolean(question.checked || isAnswered);
    const correctId = question.is_true;
    const userSelectedId = question.checked ? question[`var_${question.checked}_id`] : selectedOption;

    const isSelectedBeforeAnswer = !hasAnswered && selectedOption === optionId;

    const isCorrect = hasAnswered && optionId === correctId;
    const isWrong = hasAnswered && userSelectedId === optionId && optionId !== correctId;

    const isSuccess = isCorrect || isSelectedBeforeAnswer;

    return { isSuccess, isWrong };
  }, [question, isAnswered, selectedOption, optionId]);
